import $ from 'jquery';

// YouTube Iframe API
function initYoutubeIframeAPI(callback) {
  const iframeAPI = document.querySelector('.js-iframe-api');
  if (iframeAPI) {
    callback();
    return;
  }

  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  tag.classList.add('js-iframe-api');

  window.onYouTubeIframeAPIReady = callback;

  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function destroyYoutubeIframeAPI() {
  const iframeAPI = document.querySelector('.js-iframe-api');
  if (!iframeAPI)
    return;
  iframeAPI.remove();
  window.onYouTubeIframeAPIReady = undefined;
  window.YT = undefined;
  window.YTConfig = undefined;
}

// Inits custom YouTube player
const initPlayer = function (player) {
  if (typeof YT == 'undefined') return;

  const playerIframe = player.querySelector('.youtube-iframe');

  // Set the player options
  const playerOptions = {
    autoplay: 0,
    mute: 0,
    autohide: 1,
    modestbranding: 1,
    rel: 0,
    showinfo: 0,
    controls: 2,
    disablekb: 1,
    enablejsapi: 1,
    iv_load_policy: 3,
  };

  const playerInstance = new YT.Player(playerIframe, {
    width: '1280',
    height: '720',
    playerVars: playerOptions,
    videoId: player.dataset.videoid,
  });
};

// Destroys player
const destroyPlayer = function (player) {
  const playerId = player.querySelector('.youtube-iframe').id;
  if (playerId) {
    YT.get(playerId).destroy();
  }
};

// When YouTube API is ready, inits player depending on cookies consent
const players = Array.from(document.getElementsByClassName('youtube-player'));
if (players.length) {
  // Axeptio SDK
  window._axcb = window._axcb || [];
  window._axcb.push(function (sdk) {
    sdk.on('cookies:complete', function (choices) {
      if (choices.youtube) {
        initYoutubeIframeAPI(() => players.forEach(player => initPlayer(player)));
      } else {
        players.forEach(player => destroyPlayer(player));
        destroyYoutubeIframeAPI();
      }
    });

    // Axeptio custom consent request
    document.querySelectorAll('.yt-consent').forEach((buttonConsent) => {
      buttonConsent.addEventListener('click', () => sdk.requestConsent('youtube'));
    });
  })
}

// Plays video on Reveal pop-in open
$('.reveal--youtube').on('open.zf.reveal', function () {
  const playerId = this.querySelector('.youtube-iframe').id;
  if (playerId && window.YT) {
    window.YT.get(playerId).playVideo();
  }
});

// Pauses video on Reveal pop-in close
$('.reveal--youtube').on('closed.zf.reveal', function () {
  const playerId = this.querySelector('.youtube-iframe').id;
  if (playerId && window.YT) {
    window.YT.get(playerId).pauseVideo();
  }
});
